import type { RawAuthUser } from '@/store/authStore';

/**
 * Merge a fresh GET /user/:id payload into the persisted login snapshot without
 * dropping feature flags that may be absent from the profile response.
 */
export function mergeRawAuthUser(
  previous: RawAuthUser | null,
  incoming: Record<string, unknown>,
): RawAuthUser {
  return { ...(previous ?? {}), ...incoming };
}
